import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
import Lottie from 'react-lottie';

/*COMPONENTS */
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'
import MobileMenu from '../../components/MobileMenu'
import { ToastContainer, toast } from 'react-toastify';
import CardDataTiny from '../../components/CardDataTiny'
import CardDataAddressTiny from '../../components/CardDataAddressTiny'
import CardDataServiceTiny from '../../components/CardDataServiceTiny'
import CardDataTinyInfoSalle from '../../components/CardDataTinyInfoSalle';
import CardDataTinyTransporterInfo from '../../components/CardDataTinyTransporterInfo';
import ModalTag from '../../components/ModalTag'
import CardSaleStatusTiny from '../../components/CardSaleStatusTiny'
import { SalleContext } from '../../context/salle'
import gifImage from '../../images/animated/page-loader-dark.aHi_ewzP.gif'
import HorizontalModal from '../../components/HorizontalModal'
import animation from '../../images/animated/Animation - 1736660211116.json'
import catTiny from '../../images/svg/cat-tiny.svg'

const Animated = styled.div`
    position:absolute;
    top:50%;
    left:55%;
    right:50%;
    transform: translate(-50%,-50%);

`
const Image = styled.img`
    width: 76px;
    height:76px;
`
const CardWrapper = styled.section`
    background-color: #fafafa;
    height: 100vh;
    display: flex;

    .colum_primary{
        position: relative;
        flex:0.1;
    }
    .colum_secondary{
        display: flex;
        flex:0.8;
        padding-top: 1.2rem;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const FixWidthSidebar = styled.div`
    position: relative;
    display: block;
    width: 190px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }

    img{
        right: 30px;
        bottom: 0;
        position: absolute;
    }


`

const Salle = () => {
    const [modalPrint, setModalPrint] = useState()
    const { salle, animation, products, client, product } = useContext(SalleContext)

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }

    function Modal(props) {
        return (
            <ModalTag props={props} />
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>
                <div className='colum_primary'>
                    <SidebarEl />
                </div>
                <FixWidthSidebar>
                    <img src={catTiny}/>
                </FixWidthSidebar>

                <div className='colum_secondary'>
                    {animation == true

                        ?
                        <Animated><Image src={gifImage} /></Animated>
                        :
                        <>
                            <CardSaleStatusTiny />
                            <CardDataTiny client={salle.userName} number={salle.id} />
                            <CardDataAddressTiny  data={salle} address={salle.street} cpf={client.cpf} number={salle.number} complement={salle.complement} client={salle.userName} />
                            <CardDataServiceTiny products={products} numberItens={products.length} />
                            <CardDataTinyInfoSalle data={salle}/>
                            <CardDataTinyTransporterInfo data={salle}/>
                            <HorizontalModal />
                        </>
                    }
                    
                </div>

                <MobileMenu />
            </CardWrapper>

            <Modal
                show={modalPrint}
                onHide={() => setModalPrint(false)}

            />

        </motion.div>

    )
}

export default Salle